import { render, staticRenderFns } from "./CompanyUserEditDetailsTab.vue?vue&type=template&id=d0cf698a"
import script from "./CompanyUserEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./CompanyUserEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports